import { createContext, useContext, useState } from "react";

type AT = string | null;

type ProviderProps = {
    accessToken: AT;
    setaccessToken: React.Dispatch<React.SetStateAction<any>>;

    graphData: any;
    setgraphData: React.Dispatch<React.SetStateAction<any>>;

    account: any;
    setaccount: React.Dispatch<React.SetStateAction<any>>;

    fitdocfolder: any;
    setfitdocfolder: React.Dispatch<React.SetStateAction<any>>;

    tmpfolder: any;
    settmpfolder: React.Dispatch<React.SetStateAction<any>>;

    doctypesfolder: any;
    setdoctypesfolder: React.Dispatch<React.SetStateAction<any>>;

    doctypescollection: any;
    setdoctypescollection: React.Dispatch<React.SetStateAction<any>>;
};

// Create a default value for the context
const defaultValue: ProviderProps = {
    accessToken: null,
    setaccessToken: () => {},
    
    graphData: null,
    setgraphData: () => {},

    account: null,
    setaccount: () => {},

    fitdocfolder: null,
    setfitdocfolder: () => {},

    tmpfolder: null,
    settmpfolder: () => {},

    doctypesfolder: null,
    setdoctypesfolder: () => {},

    doctypescollection: null,
    setdoctypescollection: () => {}
};

const MSContext = createContext<ProviderProps>(defaultValue);

const MSProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const [accessToken, setaccessToken] = useState<AT>(null);
    const [graphData, setgraphData] = useState<any>(null);
    const [account, setaccount] = useState<any>(null);
    const [fitdocfolder, setfitdocfolder] = useState<any>(null);
    const [tmpfolder, settmpfolder] = useState<any>(null);
    const [doctypesfolder, setdoctypesfolder] = useState<any>(null);
    const [doctypescollection, setdoctypescollection] = useState<any>(null);

    return (
        <MSContext.Provider value={{
            accessToken, setaccessToken, 
            graphData, setgraphData, 
            account, setaccount, 
            fitdocfolder, setfitdocfolder, 
            tmpfolder, settmpfolder, 
            doctypesfolder, setdoctypesfolder,
            doctypescollection, setdoctypescollection
        }}>
            {children}
        </MSContext.Provider>
    )
}

const useMS = () => {
    return useContext(MSContext)
}

export { MSContext, MSProvider, useMS }